import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockCarouselSectionFields } from './groq';

/** Shared registry entry. Lazy: drags in embla-carousel. */
export const carouselSectionBlockConfig = {
  name: 'outer-block-carousel-section',
  component: defineAsyncComponent(() => import('./CmsCarouselSectionBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('./CarouselSection.vue')),
  fields: blockCarouselSectionFields,
} satisfies ModularBlockConfig;
